module.exports = __webpack_public_path__ + "img/empit.656b9eb1.png";